module.exports = __webpack_public_path__ + "static/media/anim-4-play.72064415.png";